/**
 * Always-visible JUMP (tap) and CROUCH (hold) buttons for the runner. They
 * complement the left-stick flick-up / hold-down so the actions are obvious and
 * reliable on touch.
 */
export interface ActionButtons {
  readonly jump: HTMLButtonElement;
  readonly crouch: HTMLButtonElement;
  dispose(): void;
}

export function createActionButtons(
  parent: HTMLElement,
  handlers: { onJump: () => void; onCrouchStart: () => void; onCrouchEnd: () => void },
): ActionButtons {
  const jump = document.createElement('button');
  jump.className = 'action-btn jump-btn';
  jump.textContent = 'JUMP';

  const crouch = document.createElement('button');
  crouch.className = 'action-btn crouch-btn';
  crouch.textContent = 'CROUCH';

  const onJumpDown = (e: PointerEvent) => {
    e.preventDefault();
    handlers.onJump();
  };
  const onCrouchDown = (e: PointerEvent) => {
    e.preventDefault();
    handlers.onCrouchStart();
  };
  const onCrouchUp = (e: PointerEvent) => {
    e.preventDefault();
    handlers.onCrouchEnd();
  };

  jump.addEventListener('pointerdown', onJumpDown);
  crouch.addEventListener('pointerdown', onCrouchDown);
  crouch.addEventListener('pointerup', onCrouchUp);
  crouch.addEventListener('pointercancel', onCrouchUp);
  crouch.addEventListener('pointerleave', onCrouchUp);

  parent.appendChild(jump);
  parent.appendChild(crouch);

  return {
    jump,
    crouch,
    dispose() {
      jump.remove();
      crouch.remove();
    },
  };
}
